import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import process from 'process';

// Polyfill process for simple-peer
(window as any).process = process;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<App />);

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const swUrl = '/sw.js';
    navigator.serviceWorker.register(swUrl)
      .then((registration) => {
        // Check for updates every 5 minutes in production
        if (process.env.NODE_ENV === 'production') {
          setInterval(() => {
            registration.update();
          }, 5 * 60 * 1000);
        }
      })
      .catch((registrationError) => {
        console.error('SW registration failed:', registrationError);
      });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
